import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27cd3bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "public-side" }
const _hoisted_2 = { class: "content has-background-contents shadow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "li-num" }, "1.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "情報をご提供いただきたい著作者", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "li-num" }, "2.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "公開調査について", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "li-num" }, "2-1.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "ご提供いただきたい情報", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "li-num" }, "2-2.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "情報ご提供までの流れ", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "li-num" }, "2-3.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "これまでの調査", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "li-num" }, "2-4.", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "お問い合わせ", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "li-num" }, "3.", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "デジタル化資料のインターネット提供について", -1))
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({ current: _ctx.pageName === 'PublicSearchResultPage' || _ctx.pageName === 'AuthorDetailPage' })
        }, [
          _hoisted_3,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/openinq/search'))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/openinq/search')), ["prevent"]), ["space","enter"])),
            class: "button-menu-searchResult"
          }, _hoisted_5, 32)
        ], 2),
        _hoisted_6,
        _createElementVNode("li", {
          class: _normalizeClass({ current: _ctx.pageName === 'PublicSearchPage' && _ctx.selectedMenu === 'openinq' })
        }, [
          _hoisted_7,
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/openinq'))),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/openinq')), ["prevent"]), ["space","enter"])),
            class: "button-menu-search"
          }, _hoisted_9, 32)
        ], 2),
        _hoisted_10,
        _createElementVNode("li", {
          class: _normalizeClass(["child-li", { current: _ctx.pageName === 'PublicSearchPage' && _ctx.selectedMenu === 'request' }])
        }, [
          _hoisted_11,
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toSearch('request'))),
            onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.toSearch('request')), ["prevent"]), ["space","enter"])),
            class: "button-menu-request"
          }, _hoisted_13, 32)
        ], 2),
        _hoisted_14,
        _createElementVNode("li", {
          class: _normalizeClass(["child-li", { current: _ctx.pageName === 'PublicSearchPage' && _ctx.selectedMenu === 'reference' }])
        }, [
          _hoisted_15,
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toSearch('reference'))),
            onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.toSearch('reference')), ["prevent"]), ["space","enter"])),
            class: "button-menu-reference"
          }, _hoisted_17, 32)
        ], 2),
        _hoisted_18,
        _createElementVNode("li", {
          class: _normalizeClass(["child-li", { current: _ctx.pageName === 'PublicSearchPage' && _ctx.selectedMenu === 'notification' }])
        }, [
          _hoisted_19,
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toSearch('notification'))),
            onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.toSearch('notification')), ["prevent"]), ["space","enter"])),
            class: "button-menu-notification"
          }, _hoisted_21, 32)
        ], 2),
        _hoisted_22,
        _createElementVNode("li", {
          class: _normalizeClass(["child-li", { current: _ctx.pageName === 'PublicSearchPage' && _ctx.selectedMenu === 'inquiry' }])
        }, [
          _hoisted_23,
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toSearch('inquiry'))),
            onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.toSearch('inquiry')), ["prevent"]), ["space","enter"])),
            class: "button-menu-inquiry"
          }, _hoisted_25, 32)
        ], 2),
        _hoisted_26,
        _createElementVNode("li", {
          class: _normalizeClass({ current: _ctx.pageName === 'PublicSearchPage' && _ctx.selectedMenu === 'chap3' })
        }, [
          _hoisted_27,
          _createElementVNode("button", {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toSearch('chap3'))),
            onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.toSearch('chap3')), ["prevent"]), ["space","enter"])),
            class: "button-menu-chap3"
          }, _hoisted_29, 32)
        ], 2)
      ])
    ])
  ]))
}